import type { ContractChoice } from '@/types/contract';

export const GET_DUGOUT_ACTIVE_PROGRAM_FAMILIES_QUERY_KEY = 'getDugoutActiveProgramFamilies';

// Mirrors DrugCategory in backend/homebase/programs/models/drug_category.py.
export enum DrugCategory {
  alcohol = 'alcohol',
  cannabis = 'cannabis',
  stimulants = 'stimulants',
  opioids = 'opioids',
  mental_health = 'mental_health'
}

export const DRUG_CATEGORIES: ContractChoice[] = [
  { value: DrugCategory.stimulants, label: 'Stimulants' },
  { value: DrugCategory.alcohol, label: 'Alcohol' },
  { value: DrugCategory.opioids, label: 'Opioids' },
  { value: DrugCategory.cannabis, label: 'Cannabis' },
  { value: DrugCategory.mental_health, label: 'Mental Health' }
];
